import {parallel} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {HoldForTurboUIAct} from '@gongxigames/framework/slotV2/ui/acts/HoldForTurboUIAct';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {JurisdictionZoneUpdateSessionBetUIAct} from '@gongxigames/framework/slotV2/ui/acts/JurisdictionZoneUpdateSessionBetUIAct';

export class HoldForTurboUIState extends UIState {
    public static readonly ID = 'HoldForTurboUIState';

    public setAct(): void {
        this.act =
            parallel([
                JurisdictionZoneUpdateSessionBetUIAct,
                HoldForTurboUIAct,
            ]);
    }

    public canExecute(): boolean {
        return slotStore.isHoldForTurboMode.value;
    }
}